import { AiSpecChat } from '@/components/ai/AiSpecChat';

export default function GenerateSpecPage() {
  return (
    <div className="p-8">
      <AiSpecChat />
    </div>
  );
}
